import { render, staticRenderFns } from "./Registrationbase.vue?vue&type=template&id=f7384dbe"
import script from "./Registrationbase.vue?vue&type=script&lang=js"
export * from "./Registrationbase.vue?vue&type=script&lang=js"
import style0 from "./Registrationbase.vue?vue&type=style&index=0&id=f7384dbe&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports